module.exports = __webpack_public_path__ + "img/three3Orange.4fc84fc4.jpg";